import {
  Checkbox,
  Dropdown,
  Image,
  Input,
  Menu,
  message,
  Modal,
  Table,
  TableColumnType,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import { svg } from "../../../../Assets/svg";
import AddDispatchLoadModal from "./Modals/AddDispatchLoadModal";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { RootState, useAppDispatch, useAppSelector } from "../../../../store";
import {
  DefaultNoImageFound,
  getThumbnailUrl,
  momentDDMMYY,
  DecriptEnv,
  getFullAwsUrl,
  CapitalizeFirstWord,
  DefaultProfileImage,
} from "../../../../helpers/utils";
import {
  GetOrdersDispatchPlanningDetailsPI,
  UpdateOrderDispatchActualManageAPI,
  UpdateOrderDispatchPlanningManageAPI,
  UpdateOrderDispatchFilesAPI,
  UpdateOrderDispatchStatusAPI,
} from "../../../Redux/orders";
import { uploadFileToS3, deleteFromS3 } from "../../../../helpers/awsUpload";
import FullScreenLoader from "../../../Components/FullScreenLoader";
import DispatchDetailsModal from "./Modals/DispatchDetailsModal";
import CommonDeleteModal from "../../../Components/Modals/CommonDeleteModal";
import OverLoadConfirmationModal from "./Modals/OverLoadConfirmationModal";
import MarkAsDoneDispatchModal from "./Modals/MarkAsDoneDispatchModal";
import AddDispatchTeamModal from "./Modals/AddDispatchTeamModal";
import CommonFilePreviewModal from "../../../Components/CommonFilePreviewModal";
import FillDispatchChecklistModal from "./Modals/FillDispatchChecklistModal";
import ViewDispatchChecklistModal from "./Modals/ViewDispatchChecklistModal";

import { BtnLoader } from "../../../../Components/Components";
import { decryptByText } from "../../../../helpers/bycrypt";
import { DispatchPlaningStatusArray } from "../orderTypes";
import {
  ProductFinishEnum,
  ProductFinishLabels,
} from "../../Products/productsTypes";
import { EyeOutlined } from "@ant-design/icons";
import DispatchLastLoadErrorModal from "./Modals/DispatchLastLoadErrorModal";
import DescriptionWithShowMore from "../../../../helpers/DescriptionWithShowMore";

const buildItemDescription = (product: any) => {
  // const attrs = product?.variants?.[0]?.attributes || {};
  // const parts = [
  //   attrs?.length ? `Length: ${attrs.length}mm` : "",
  //   attrs?.height ? `Height: ${attrs.height}mm` : "",
  //   attrs?.width ? `Width: ${attrs.width}mm` : "",
  //   attrs?.depth ? `Depth: ${attrs.depth}mm` : "",
  //   attrs?.thickness ? `Thickness: ${attrs.thickness}mm` : "",
  //   attrs?.finish
  //     ? `Finish: ${ProductFinishLabels[attrs.finish as ProductFinishEnum]}`
  //     : "",
  //   attrs?.color ? `Color: ${attrs.color}` : "",
  // ].filter(Boolean);
  // return parts.join(" | ");
  return product?.description || "";
};

const buildTransferSummary = (entry: any) => {
  if (!entry) return "";
  const parts: string[] = [];
  const overDispatchedQty = Number(entry?.over_dispatched_qty || 0);
  if (overDispatchedQty > 0) {
    parts.push(`Over: ${overDispatchedQty}`);
  }

  const takenFromLoads = Array.isArray(entry?.taken_from_loads)
    ? entry.taken_from_loads
    : [];
  if (takenFromLoads.length) {
    const takenText = takenFromLoads
      .map(
        (elem: any) =>
          `Load ${Number(elem?.load_number || 0)}: ${Number(elem?.qty || 0)}`,
      )
      .join(", ");
    parts.push(`Taken from ${takenText}`);
  }

  const givenToLoads = Array.isArray(entry?.given_to_loads)
    ? entry.given_to_loads
    : [];
  if (givenToLoads.length) {
    const givenText = givenToLoads
      .map(
        (elem: any) =>
          `Load ${Number(elem?.load_number || 0)}: ${Number(elem?.qty || 0)}`,
      )
      .join(", ");
    parts.push(`Given to ${givenText}`);
  }

  return parts.join(" | ");
};

const buildTransferDetails = (entry: any) => {
  if (!entry) {
    return {
      over: 0,
      takenText: "",
      givenText: "",
    };
  }

  const over = Number(entry?.over_dispatched_qty || 0);
  const takenFromLoads = Array.isArray(entry?.taken_from_loads)
    ? entry.taken_from_loads
    : [];
  const givenToLoads = Array.isArray(entry?.given_to_loads)
    ? entry.given_to_loads
    : [];

  const takenText = takenFromLoads.length
    ? takenFromLoads
        .map(
          (elem: any) =>
            `L${Number(elem?.load_number || 0)}: ${Number(elem?.qty || 0)}`,
        )
        .join(", ")
    : "";
  const givenText = givenToLoads.length
    ? givenToLoads
        .map(
          (elem: any) =>
            `L${Number(elem?.load_number || 0)}: ${Number(elem?.qty || 0)}`,
        )
        .join(", ")
    : "";

  return {
    over,
    takenText,
    givenText,
  };
};

const getDispatchItemKey = (item: any) => {
  if (item?.production_item_id)
    return `production:${String(item.production_item_id)}`;
  if (item?.service_order_id) return `service:${String(item.service_order_id)}`;
  return item?._id ? String(item._id) : "";
};

const buildDispatchIdentityPayload = (row: any) => {
  if (row?.production_item_id) {
    return { production_item_id: row.production_item_id };
  }
  if (row?.service_order_id) {
    return { service_order_id: row.service_order_id };
  }
  return {};
};

const DispatchPlanning = ({
  isModifyDispatchPlaning,
  setIsModifyDispatchPlaning,
}: any) => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { orderDetails, dispatchPlaningDetails } = useAppSelector(
    (state: RootState) => state.orders,
  );

  const {
    getDispatchPlaningDetailsLoading,
    updateDispatchPlanningManageLoading,
    updateDispatchActualManageLoading,
  } = useAppSelector((state: RootState) => state.loading);

  const [dispatchPlaning, setDispatchPlaning] = useState<any>(null);

  const [tempProducts, setTempProducts] = useState<any[]>([]);
  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editingRowBackup, setEditingRowBackup] = useState<any>(null);
  const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);

  const [addIsLoadModal, setAddIsLoadModal] = useState(false);
  const [isEditLoadData, setIsEditLoadData] = useState<any>(null);

  const [isDispatchQty, setIsDispatchQty] = useState(false);

  const [activeKey, setActiveKey] = useState<any>(null);

  const [isDispatchDetails, setIsDispatchDetails] = useState(false);
  const [isDispatchDetailsData, setIsDispatchDetailsData] = useState(false);

  const [selectedLoadData, setSelectedLoadData] = useState<any>(null);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [uploadingId, setUploadingId] = useState<any>(null);
  const [isDeleteId, setIsDeleteId] = useState<any>(null);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [deleteFileLoader, setDeleteFileLoader] = useState(false);

  const [isOverDispatchModal, setIsOverDispatchModal] = useState(false);
  const [isOverDispatchData, setIsOverDispatchData] = useState<any>(null);

  const [isMarkAsDispatch, setIsMarkAsDispatch] = useState(false);
  const [isDispatchChecklistModal, setIsDispatchChecklistModal] = useState(false);
  const [isViewDispatchChecklistModalOpen, setIsViewDispatchChecklistModalOpen] = useState(false);
  const [pendingDispatchChecklist, setPendingDispatchChecklist] = useState<any>(null);
  const [previewFiles, setPreviewFiles] = useState<any[]>([]);
  const [previewIndex, setPreviewIndex] = useState<number>(0);
  const [previewModalOpen, setPreviewModalOpen] = useState<boolean>(false);
  const [undispatchedModalOpen, setUndispatchedModalOpen] =
    useState<boolean>(false);
  const [undispatchedProductsList, setUndispatchedProductsList] = useState<
    any[]
  >([]);

  useEffect(() => {
    if (id) {
      dispatch(GetOrdersDispatchPlanningDetailsPI({ order_id: id }));
      dispatch({ type: "CLEAR_TEAM_MEMBER_ARRAY" });
    }
  }, [id, dispatch]);

  const mappedProductsFromApi = useMemo(() => {
    const items = dispatchPlaningDetails?.item_id || [];
    const loads = dispatchPlaningDetails?.load_id || [];

    const itemMap = new Map<string, any>();

    // First, populate all items from the order (unchecked & checked)
    items.forEach((item: any) => {
      const key = getDispatchItemKey(item);
      if (!key) return;

      const productImage =
        item?.product?.pre_galvanised_image ||
        item?.product?.hot_dip_galvanised_image ||
        item?.product?.powder_coated_image ||
        item?.product?.image ||
        "";

      itemMap.set(key, {
        _id: key,
        production_item_id: item?.production_item_id || null,
        service_order_id: item?.service_order_id || null,
        service_details: item?.service_details || null,
        item_type: item?.item_type || null,
        image: productImage,
        name: item?.name || item?.product?.name || "-",
        labelInQuotation: item?.labelInQuotation || null,
        totalQuantity: Number(item?.order_qty || 0),
        availableQuantity: Number(item?.order_qty || 0),
        description: buildItemDescription(item?.product),
        categories_snapshot: item?.categories_snapshot || null,
        loadItemIds: {},
        loads: {},
        dispatchedLoads: {},
        loadMeta: {},
        inAnyLoad: false, // track if it's assigned to any load
      });
    });

    // Next, fill in the load quantities from assigned loads
    loads.forEach((load: any) => {
      const loadId = load?._id;
      (load?.items || []).forEach((item: any) => {
        const key = getDispatchItemKey(item);
        if (!key) return;

        if (!itemMap.has(key)) {
          // Fallback if somehow it's in a load but not in item_id
          const productImage =
            item?.product?.pre_galvanised_image ||
            item?.product?.hot_dip_galvanised_image ||
            item?.product?.powder_coated_image ||
            item?.product?.image ||
            "";
          itemMap.set(key, {
            _id: key,
            production_item_id: item?.production_item_id || null,
            service_order_id: item?.service_order_id || null,
            service_details: item?.service_details || null,
            item_type: item?.item_type || null,
            image: productImage,
            name: item?.name || item?.product?.name || "-",
            labelInQuotation: item?.labelInQuotation || null,
            totalQuantity: Number(item?.order_qty || 0),
            availableQuantity: Number(item?.order_qty || 0),
            description: buildItemDescription(item?.product),
            categories_snapshot: item?.categories_snapshot || null,
            loadItemIds: {},
            loads: {},
            dispatchedLoads: {},
            loadMeta: {},
            inAnyLoad: false,
          });
        }

        const row = itemMap.get(key);
        row.inAnyLoad = true;
        row.loadItemIds[loadId] = item?._id || null;
        row.loads[loadId] = Number(item?.planned_qty || 0);
        row.dispatchedLoads[loadId] = Number(item?.dispatched_qty || 0);
        row.loadMeta[loadId] = {
          remaining_qty: Number(item?.remaining_qty || 0),
          over_dispatched_qty: Number(item?.over_dispatched_qty || 0),
          taken_from_loads: Array.isArray(item?.taken_from_loads)
            ? item.taken_from_loads
            : [],
          given_to_loads: Array.isArray(item?.given_to_loads)
            ? item.given_to_loads
            : [],
        };
      });
    });

    return Array.from(itemMap.values());
  }, [dispatchPlaningDetails]);

  const groupedItems = useMemo(() => {
    let products = tempProducts || [];
    const groupsMap: Record<
      string,
      { category: any; items: any[]; parts: any[]; components: any[] }
    > = {};
    const otherItems: any[] = [];
    const services: any[] = [];

    if (isModifyDispatchPlaning && isDispatchQty) {
      products = products.filter((item) => {
        const plannedQty = Number(item.loads?.[activeKey] || 0);
        const totalQty = Number(item.totalQuantity || 0);
        const otherDispatched = Object.entries(
          item.dispatchedLoads || {},
        ).reduce(
          (sum, [lId, val]) =>
            String(lId) === String(activeKey) ? sum : sum + Number(val || 0),
          0,
        );
        const currentDispatched = Number(
          item.dispatchedLoads?.[activeKey] || 0,
        );

        if (
          plannedQty === 0 &&
          otherDispatched >= totalQty &&
          currentDispatched === 0
        ) {
          return false;
        }
        return true;
      });
    }

    products.forEach((item) => {
      if (item.item_type === "service") {
        services.push(item);
      } else if (item.categories_snapshot?._id) {
        const catId = item.categories_snapshot._id;
        if (!groupsMap[catId]) {
          groupsMap[catId] = {
            category: item.categories_snapshot,
            items: [],
            parts: [],
            components: [],
          };
        }
        if (item.item_type === "bom_part") {
          groupsMap[catId].parts.push(item);
        } else if (item.item_type === "component") {
          groupsMap[catId].components.push(item);
        } else {
          groupsMap[catId].items.push(item);
        }
      } else {
        otherItems.push(item);
      }
    });

    return {
      categoryGroups: Object.values(groupsMap),
      otherItems,
      services,
    };
  }, [tempProducts, isModifyDispatchPlaning, isDispatchQty, activeKey]);

  useEffect(() => {
    if (!dispatchPlaningDetails) {
      setDispatchPlaning(null);
      return;
    }

    const products = mappedProductsFromApi;
    setDispatchPlaning({
      loads: Number(dispatchPlaningDetails?.load_number || 0),
      products,
      loadDetails: {},
    });
    setTempProducts(products);
    setSelectedRowIds(
      products.filter((p: any) => p.inAnyLoad).map((p: any) => p._id),
    );

    const allLoads = dispatchPlaningDetails?.load_id || [];
    const firstLoad = allLoads[0];
    const hasActiveLoad = allLoads.some((elem: any) => elem?._id === activeKey);

    if (firstLoad?._id) {
      const nextActiveKey = hasActiveLoad ? activeKey : firstLoad._id;
      const selectedLoad =
        allLoads.find((elem: any) => elem?._id === nextActiveKey) || firstLoad;
      setActiveKey(nextActiveKey);
      setSelectedLoadData(selectedLoad);
    } else {
      setActiveKey(null);
      setSelectedLoadData(null);
    }
  }, [dispatchPlaningDetails, mappedProductsFromApi, activeKey]);

  const items: TabsProps["items"] = useMemo(() => {
    if (dispatchPlaningDetails?.load_id?.length > 0) {
      return dispatchPlaningDetails.load_id.map((elem: any) => ({
        key: elem?._id,
        label: `Load ${elem?.load_number}`,
        children: "",
      }));
    }
    return [];
  }, [dispatchPlaningDetails]);

  const loadNumberById = useMemo(() => {
    const map = new Map<string, number>();
    (dispatchPlaningDetails?.load_id || []).forEach((load: any) => {
      map.set(String(load?._id), Number(load?.load_number || 0));
    });
    return map;
  }, [dispatchPlaningDetails]);

  const getPlanningBounds = useCallback((row: any, loadId: string) => {
    const totalQty = Number(row?.totalQuantity || 0);
    const dispatchedForLoad = Number(row?.dispatchedLoads?.[loadId] || 0);
    const otherPlanned = Object.entries(row?.loads || {}).reduce(
      (sum: number, [key, value]: any) =>
        String(key) === String(loadId) ? sum : sum + Number(value || 0),
      0,
    );
    return {
      min: Math.max(0, dispatchedForLoad),
      max: Math.max(0, totalQty - otherPlanned),
    };
  }, []);

  const getPlanningSummary = useCallback((row: any) => {
    const totalPlanned = Object.values(row?.loads || {}).reduce(
      (sum: number, value: any) => sum + Number(value || 0),
      0,
    );
    const orderQty = Number(row?.totalQuantity || 0);
    const remainingToPlan = orderQty - totalPlanned;
    return {
      totalPlanned,
      orderQty,
      remainingToPlan,
      canAddMore: Math.max(remainingToPlan, 0),
    };
  }, []);

  const getDispatchedBounds = useCallback((row: any, loadId: string) => {
    const totalQty = Number(row?.totalQuantity || 0);
    const otherDispatched = Object.entries(row?.dispatchedLoads || {}).reduce(
      (sum: number, [key, value]: any) =>
        String(key) === String(loadId) ? sum : sum + Number(value || 0),
      0,
    );
    return {
      min: 0,
      max: Math.max(0, totalQty - otherDispatched),
    };
  }, []);

  const getOverDispatchPreview = useCallback(
    (row: any, loadId: string) => {
      const planned = Number(row?.loads?.[loadId] || 0);
      const dispatched = Number(row?.dispatchedLoads?.[loadId] || 0);
      const extra = Math.max(dispatched - planned, 0);
      if (extra <= 0) return null;

      const donors = Object.entries(row?.loads || {})
        .filter(([key]) => String(key) !== String(loadId))
        .map(([key, value]: any) => ({
          load_id: String(key),
          load_number: Number(loadNumberById.get(String(key)) || 0),
          remaining: Math.max(
            Number(value || 0) - Number(row?.dispatchedLoads?.[key] || 0),
            0,
          ),
        }))
        .filter((d) => d.remaining > 0)
        .sort((a, b) => a.load_number - b.load_number);

      let need = extra;
      const allocations: Array<{ load_number: number; qty: number }> = [];
      for (const donor of donors) {
        if (need <= 0) break;
        const qty = Math.min(need, donor.remaining);
        if (qty <= 0) continue;
        allocations.push({ load_number: donor.load_number, qty });
        need -= qty;
      }

      return {
        extra,
        allocations,
        remaining_over_dispatched: Math.max(need, 0),
      };
    },
    [loadNumberById],
  );

  const handleQuantityChange = useCallback(
    (productId: string, loadKey: string, newValue: number) => {
      setTempProducts((prev) =>
        prev.map((p) => {
          if (p._id === productId) {
            let finalValue = Math.max(0, newValue);
            return {
              ...p,
              loads: {
                ...p.loads,
                [loadKey]: finalValue,
              },
            };
          }
          return p;
        }),
      );
    },
    [],
  );

  const handleDispatchedQuantityChange = useCallback(
    (productId: string, loadKey: string, newValue: number) => {
      setTempProducts((prev) =>
        prev.map((p) => {
          if (p._id === productId) {
            let finalValue = Math.max(0, newValue);
            return {
              ...p,
              dispatchedLoads: {
                ...(p.dispatchedLoads || {}),
                [loadKey]: finalValue,
              },
            };
          }
          return p;
        }),
      );
    },
    [],
  );

  const columns: TableColumnType<any>[] = useMemo(
    () => [
      {
        title: "Product",
        dataIndex: "name",
        key: "name",
        render: (text: string, record: any) => {
          console.log(record, "recordrecordrecordrecord");
          return (
            <div className="d-flex gap-2">
              <Image
                src={
                  record?.image && record?.image !== DefaultNoImageFound
                    ? getThumbnailUrl(record?.image)
                    : DefaultNoImageFound
                }
                alt={record?.image}
                className="rounded-2 object-fit-cover border w-100 h-100"
                rootClassName="img-45"
                fallback={DefaultNoImageFound}
                preview={{
                  mask: <EyeOutlined />, // 👈 custom icon here
                }}
              />
              <div className="d-flex flex-column justify-content-center">
                <h6 className="fw-semibold mb-0 text-dark fs-6 mb-1">
                  {record?.name}
                </h6>
                <h6
                  className="mb-0 text-dark fs-7 dispatchTableProduct"
                  style={{ fontSize: "0.875rem" }}
                >
                  {record?.description}
                </h6>
                {buildTransferSummary(record?.loadMeta?.[activeKey]) ? (
                  <div className="fs-7 text-secondary mt-1">
                    {buildTransferSummary(record?.loadMeta?.[activeKey])}
                  </div>
                ) : null}
              </div>
            </div>
          );
        },
      },
      {
        title: "Planned Qty",
        dataIndex: "quantity",
        key: "quantity",
        width: 150,
        render: (_, record) => (
          <div>
            <div>{record.loads[activeKey] || 0}</div>
            <div className="fs-8 text-secondary">
              {record?.labelInQuotation || "Qty"}
            </div>
          </div>
        ),
      },
      {
        title: "Dispatched Qty",
        dataIndex: "dispatched",
        key: "dispatched",
        width: 150,
        render: (_, record) => {
          const qty = Number(record.dispatchedLoads?.[activeKey] || 0);
          const transfer = buildTransferDetails(record?.loadMeta?.[activeKey]);
          return (
            <div>
              <div>{qty}</div>
              <div className="fs-8 text-secondary">
                {record?.labelInQuotation || "Qty"}
              </div>
              {transfer.over > 0 ? (
                <div className="fs-8 text-danger">Over: {transfer.over}</div>
              ) : null}
              {transfer.takenText ? (
                <div className="fs-8 text-secondary">
                  Taken: {transfer.takenText}
                </div>
              ) : null}
              {transfer.givenText ? (
                <div className="fs-8 text-secondary">
                  Given: {transfer.givenText}
                </div>
              ) : null}
            </div>
          );
        },
      },
    ],
    [activeKey],
  );

  const modifyDispatchPlaningColumns: TableColumnType<any>[] = useMemo(() => {
    const baseCols: TableColumnType<any>[] = [
      {
        title: "Items",
        dataIndex: "name",
        key: "name",
        width: 500,
        render: (text: string, record: any) => (
          <div className="d-flex align-items-start gap-2">
            <Checkbox
              checked={selectedRowIds.includes(record._id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedRowIds((prev) => [...prev, record._id]);
                } else {
                  setSelectedRowIds((prev) =>
                    prev.filter((id) => id !== record._id),
                  );
                }
              }}
              className="mt-1"
            />
            <Image
              src={
                record?.image && record?.image !== DefaultNoImageFound
                  ? getThumbnailUrl(record?.image)
                  : DefaultNoImageFound
              }
              alt={record?.image}
              className="rounded-2 object-fit-cover border w-100 h-100"
              rootClassName="img-45"
              fallback={DefaultNoImageFound}
              preview={{
                mask: <EyeOutlined />, // 👈 custom icon here
              }}
            />
            <div>
              <h6 className="fw-semibold mb-0 text-dark fs-6">
                {record?.name}
              </h6>
              <div className="fs-7 text-secondary mb-1">
                {record?.labelInQuotation || "Qty"} - {record?.totalQuantity}
              </div>
              <h6 className="mb-0 text-secondary" style={{ fontSize: "12px" }}>
                <DescriptionWithShowMore description={record?.description} />
              </h6>
              {buildTransferSummary(record?.loadMeta?.[activeKey]) ? (
                <div className="fs-7 text-secondary mt-1">
                  {buildTransferSummary(record?.loadMeta?.[activeKey])}
                </div>
              ) : null}
            </div>
          </div>
        ),
      },
    ];

    const loadCols = (dispatchPlaningDetails?.load_id || []).map(
      (load: any) => {
        const loadKey = load?._id;
        return {
          title: `Load ${load?.load_number}`,
          children: [
            {
              title: "Planning Qty",
              dataIndex: ["loads", loadKey],
              key: `load_planning_${loadKey}`,
              width: 120,
              render: (value: number, record: any) => {
                const isEditing = editingRowId === record._id;
                const isSelected = selectedRowIds.includes(record._id);

                if (!isSelected)
                  return <span className="text-secondary">-</span>;

                return isEditing ? (
                  <div className="page-form">
                    {(() => {
                      const bounds = getPlanningBounds(record, loadKey);
                      const summary = getPlanningSummary(record);
                      const currentValue = Number(
                        record?.loads?.[loadKey] || 0,
                      );
                      const isInvalid =
                        currentValue < bounds.min || currentValue > bounds.max;
                      return (
                        <>
                          <Input
                            type="number"
                            value={record.loads[loadKey]}
                            onChange={(e) =>
                              handleQuantityChange(
                                record._id,
                                loadKey,
                                parseInt(e.target.value) || 0,
                              )
                            }
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                              ];

                              if (
                                allowedKeys.includes(e.key) ||
                                (e.key >= "0" && e.key <= "9")
                              ) {
                                return;
                              }

                              e.preventDefault();
                            }}
                            className="w-100"
                            status={isInvalid ? "error" : ""}
                          />
                        </>
                      );
                    })()}
                  </div>
                ) : (
                  <div>
                    <div>{value || 0}</div>
                    <div className="fs-8 text-secondary">
                      {record?.labelInQuotation || "Qty"}
                    </div>
                  </div>
                );
              },
            },
            {
              title: "Dispatched Qty",
              dataIndex: ["dispatchedLoads", loadKey],
              key: `load_dispatched_${loadKey}`,
              width: 120,
              render: (value: number, record: any) => {
                const isSelected = selectedRowIds.includes(record._id);
                if (!isSelected)
                  return <span className="text-secondary">-</span>;
                return (
                  <div>
                    <div>{value || 0}</div>
                    <div className="fs-8 text-secondary">
                      {record?.labelInQuotation || "Qty"}
                    </div>
                  </div>
                );
              },
            },
          ],
        };
      },
    );

    const actionCol: TableColumnType<any> = {
      title: "Action",
      key: "action",
      width: 100,
      align: "center",
      render: (_, record) => {
        const isEditing = editingRowId === record._id;
        const isSelected = selectedRowIds.includes(record._id);

        if (!isSelected) return null;

        if (isEditing) {
          const summary = getPlanningSummary(record);
          const isPlanningBalanced = summary.remainingToPlan === 0;
          let hasCellInvalid = false;
          for (const load of dispatchPlaningDetails?.load_id || []) {
            const loadKey = String(load?._id);
            const value = Number(record?.loads?.[loadKey] || 0);
            const bounds = getPlanningBounds(record, loadKey);
            if (value < bounds.min || value > bounds.max) {
              hasCellInvalid = true;
              break;
            }
          }
          const canConfirm = isPlanningBalanced && !hasCellInvalid;

          return (
            <div className="d-flex align-items-center justify-content-center gap-2">
              <span
                className="cursor-pointer"
                onClick={() => {
                  const summary = getPlanningSummary(record);
                  if (summary.remainingToPlan !== 0) {
                    message.error(
                      `Confirmation is not allowed because the planning quantity exceeds the production order quantity.`,
                    );
                    return;
                  }

                  let invalidLoadMsg = "";
                  for (const load of dispatchPlaningDetails?.load_id || []) {
                    const loadKey = String(load?._id);
                    const value = Number(record?.loads?.[loadKey] || 0);
                    const bounds = getPlanningBounds(record, loadKey);
                    if (value < bounds.min || value > bounds.max) {
                      invalidLoadMsg = `Load ${load?.load_number} planning qty must be between ${bounds.min} and ${bounds.max}.`;
                      break;
                    }
                  }

                  if (invalidLoadMsg) {
                    message.error(invalidLoadMsg);
                    return;
                  }

                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
              >
                {svg?.checkButton}
              </span>
              <span
                className="cursor-pointer"
                onClick={() => {
                  setTempProducts((prev: any) =>
                    prev.map((item: any) =>
                      item._id === record._id ? editingRowBackup || item : item,
                    ),
                  );
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
              >
                {svg?.crossButton}
              </span>
            </div>
          );
        }

        return (
          <span
            role="button"
            style={{ opacity: editingRowId ? "0.5" : "1" }}
            className="cursor-pointer"
            onClick={() => {
              if (editingRowId) return;
              setEditingRowId(record._id);
              setEditingRowBackup({ ...record });
            }}
          >
            {svg?.editTableIcon}
          </span>
        );
      },
    };

    return [...baseCols, ...loadCols, actionCol];
  }, [
    dispatchPlaningDetails,
    tempProducts,
    editingRowId,
    selectedRowIds,
    handleQuantityChange,
    getPlanningBounds,
    getPlanningSummary,
  ]);

  const dispatchQtyColumns: TableColumnType<any>[] = useMemo(() => {
    const baseCols: TableColumnType<any>[] = [
      {
        title: "Items",
        dataIndex: "name",
        key: "name",
        width: 500,
        render: (text: string, record: any) => {
          const totalDispatched = Object.entries(record?.dispatchedLoads || {}).reduce(
            (sum: number, [_, qty]) => sum + Number(qty || 0),
            0,
          );
          const remainingToDispatch = Math.max(0, Number(record?.totalQuantity || 0) - totalDispatched);
          return (
            <div className="d-flex align-items-start gap-2">
              <Image
                src={
                  record?.image && record?.image !== DefaultNoImageFound
                    ? getThumbnailUrl(record?.image)
                    : DefaultNoImageFound
                }
                alt={record?.image}
                className="rounded-2 object-fit-cover border w-100 h-100"
                rootClassName="img-45"
                fallback={DefaultNoImageFound}
                preview={{
                  mask: <EyeOutlined />, // 👈 custom icon here
                }}
              />
              <div>
                <h6 className="fw-semibold mb-0 text-dark fs-6">
                  {record?.name}
                </h6>
                <div className="fs-7 text-secondary mb-1">
                  {record?.labelInQuotation || "Qty"} - {record?.totalQuantity} | Remaining To Dispatch: {remainingToDispatch}
                </div>
                <h6 className="mb-0 text-secondary" style={{ fontSize: "12px" }}>
                   <DescriptionWithShowMore description={record?.description} />
                </h6>
              </div>
            </div>
          );
        },
      },
      {
        title: "Planned Qty",
        dataIndex: ["loads", activeKey],
        key: `planned_${activeKey}`,
        width: 120,
        render: (value: number, record: any) => (
          <div>
            <div>{value || 0}</div>
            <div className="fs-8 text-secondary">
              {record?.labelInQuotation || "Qty"}
            </div>
          </div>
        ),
      },
      {
        title: "Dispatched Qty",
        dataIndex: ["dispatchedLoads", activeKey],
        key: `dispatched_${activeKey}`,
        width: 150,
        render: (value: number, record: any) => {
          const isEditing = editingRowId === record._id;
          return isEditing ? (
            <div className="page-form">
              {(() => {
                const bounds = getDispatchedBounds(record, activeKey);
                const currentValue = Number(
                  record?.dispatchedLoads?.[activeKey] || 0,
                );
                const isInvalid =
                  currentValue < bounds.min || currentValue > bounds.max;
                return (
                  <>
                    <Input
                      type="number"
                      value={record.dispatchedLoads?.[activeKey]}
                      onChange={(e) =>
                        handleDispatchedQuantityChange(
                          record._id,
                          activeKey,
                          parseInt(e.target.value) || 0,
                        )
                      }
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        if (
                          allowedKeys.includes(e.key) ||
                          (e.key >= "0" && e.key <= "9")
                        ) {
                          return;
                        }
                        e.preventDefault();
                      }}
                      className="w-100"
                      status={isInvalid ? "error" : ""}
                    />
                  </>
                );
              })()}
            </div>
          ) : (
            <div>
              <div>{value || 0}</div>
              <div className="fs-8 text-secondary">
                {record?.labelInQuotation || "Qty"}
              </div>
              {(() => {
                const transfer = buildTransferDetails(
                  record?.loadMeta?.[activeKey],
                );
                return (
                  <>
                    {transfer.over > 0 ? (
                      <div className="fs-8 text-danger">
                        Over: {transfer.over}
                      </div>
                    ) : null}
                    {transfer.takenText ? (
                      <div className="fs-8 text-secondary">
                        Taken: {transfer.takenText}
                      </div>
                    ) : null}
                    {transfer.givenText ? (
                      <div className="fs-8 text-secondary">
                        Given: {transfer.givenText}
                      </div>
                    ) : null}
                  </>
                );
              })()}
            </div>
          );
        },
      },
    ];

    const actionCol: TableColumnType<any> = {
      title: "Action",
      key: "action",
      width: 100,
      align: "center",
      render: (_, record) => {
        const isEditing = editingRowId === record._id;

        return isEditing ? (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <span
              className="cursor-pointer"
              onClick={() => {
                const bounds = getDispatchedBounds(record, activeKey);
                const currentValue = Number(
                  record?.dispatchedLoads?.[activeKey] || 0,
                );
                if (currentValue < bounds.min || currentValue > bounds.max) {
                  message.error(
                    `Dispatched qty must be between ${bounds.min} and ${bounds.max}.`,
                  );
                  return;
                }
                setEditingRowId(null);
                setEditingRowBackup(null);
              }}
            >
              {svg?.checkButton}
            </span>
            <span
              className="cursor-pointer"
              onClick={() => {
                setTempProducts((prev: any) =>
                  prev.map((item: any) =>
                    item._id === record._id ? editingRowBackup || item : item,
                  ),
                );
                setEditingRowId(null);
                setEditingRowBackup(null);
              }}
            >
              {svg?.crossButton}
            </span>
          </div>
        ) : (
          <span
            role="button"
            style={{ opacity: editingRowId ? "0.5" : "1" }}
            className="cursor-pointer"
            onClick={() => {
              if (editingRowId) return;
              setEditingRowId(record._id);
              setEditingRowBackup({ ...record });
            }}
          >
            {svg?.editTableIcon}
          </span>
        );
      },
    };

    return [...baseCols, actionCol];
  }, [
    activeKey,
    tempProducts,
    editingRowId,
    handleDispatchedQuantityChange,
    dispatchPlaning?.products,
  ]);

  const submitActualDispatch = () => {
    const items = tempProducts
      .filter(
        (row: any) =>
          Number(row?.loads?.[activeKey] || 0) > 0 ||
          Number(row?.dispatchedLoads?.[activeKey] || 0) > 0 ||
          row?.loadItemIds?.[activeKey],
      )
      .map((row: any) => {
        const payload: any = {
          ...buildDispatchIdentityPayload(row),
          dispatched_qty: Number(row?.dispatchedLoads?.[activeKey] || 0),
        };
        if (row?.loadItemIds?.[activeKey]) {
          payload._id = row.loadItemIds[activeKey];
        }
        return payload;
      });

    const payload = {
      order_id: id,
      updates: [
        {
          load_id: activeKey,
          items,
        },
      ],
    };

    dispatch(
      UpdateOrderDispatchActualManageAPI(payload, () => {
        setIsModifyDispatchPlaning(false);
        setEditingRowId(null);
        setIsOverDispatchModal(false);
        setIsOverDispatchData(null);
      }),
    );
  };

  const onSave = () => {
    if (!id) return;

    if (!isDispatchQty) {
      for (const row of tempProducts.filter((p: any) =>
        selectedRowIds.includes(p?._id),
      )) {
        const summary = getPlanningSummary(row);
        if (summary.remainingToPlan !== 0) {
          message.error(
            `${row?.name}: remaining planning qty must be 0 before save. Current remaining: ${summary.remainingToPlan}.`,
          );
          return;
        }
        for (const load of dispatchPlaningDetails?.load_id || []) {
          const loadId = String(load?._id);
          const loadNumber = Number(load?.load_number || 0);
          const plannedQty = Number(row?.loads?.[loadId] || 0);
          const bounds = getPlanningBounds(row, loadId);
          if (plannedQty < bounds.min || plannedQty > bounds.max) {
            message.error(
              `${row?.name}: Load ${loadNumber} planning qty must be between ${bounds.min} and ${bounds.max}.`,
            );
            return;
          }
        }
      }

      const updates = (dispatchPlaningDetails?.load_id || []).map(
        (load: any) => {
          const loadId = load?._id;
          const items: any[] = [];

          tempProducts.forEach((row: any) => {
            if (selectedRowIds.includes(row?._id)) {
              const payload: any = {
                ...buildDispatchIdentityPayload(row),
                planned_qty: Number(row?.loads?.[loadId] || 0),
              };
              if (row?.loadItemIds?.[loadId]) {
                payload._id = row.loadItemIds[loadId];
              }
              items.push(payload);
            } else {
              if (row?.loadItemIds?.[loadId]) {
                items.push({
                  _id: row.loadItemIds[loadId],
                  ...buildDispatchIdentityPayload(row),
                  remove: 1,
                });
              }
            }
          });

          return {
            load_id: loadId,
            items,
          };
        },
      );

      const payload = {
        order_id: id,
        updates,
      };

      dispatch(
        UpdateOrderDispatchPlanningManageAPI(payload, () => {
          setIsModifyDispatchPlaning(false);
          setEditingRowId(null);
        }),
      );
      return;
    }

    const activeLoadId = activeKey;
    if (!activeLoadId) {
      message.error("Please select a load.");
      return;
    }

    const activeRows = tempProducts.filter(
      (row: any) => Number(row?.loads?.[activeLoadId] || 0) > 0,
    );

    for (const row of activeRows) {
      const dispatchedQty = Number(row?.dispatchedLoads?.[activeLoadId] || 0);
      const bounds = getDispatchedBounds(row, activeLoadId);
      if (dispatchedQty < bounds.min || dispatchedQty > bounds.max) {
        const loadNumber = Number(
          loadNumberById.get(String(activeLoadId)) || 0,
        );
        message.error(
          `${row?.name}: Load ${loadNumber} dispatched qty must be between ${bounds.min} and ${bounds.max}.`,
        );
        return;
      }
    }

    const confirmations: string[] = [];
    for (const row of activeRows) {
      const preview = getOverDispatchPreview(row, activeLoadId);
      if (!preview) continue;
      const fromText = preview.allocations.length
        ? preview.allocations
            .map((a) => `Load ${a.load_number}: ${a.qty}`)
            .join(", ")
        : "no available load";
      const pendingText =
        preview.remaining_over_dispatched > 0
          ? `, remaining over-dispatched: ${preview.remaining_over_dispatched}`
          : "";
      confirmations.push(
        `${row?.name}'s extra ${preview.extra} quantity will be taken from ${fromText}${pendingText}.`,
      );
    }

    if (confirmations.length > 0) {
      setIsOverDispatchData(confirmations);
      setIsOverDispatchModal(true);
      return;
    }

    submitActualDispatch();
  };

  const handleUploadFiles = async (
    e: any,
    categorySnapId: string | null = null,
    imageType: string = "product",
  ) => {
    if (!id || !selectedLoadData?._id) return;
    const files = e.target.files;
    if (!files || files.length === 0) return;

    setUploadingFiles(true);
    setUploadingId(categorySnapId);
    try {
      const uploadedFiles: any[] = [];
      const bucketName =
        DecriptEnv(process.env.REACT_APP_AWS_BUCKET_NAME) || "";

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        let folder = "dispatch_files";
        if (
          !file.type.startsWith("image/") &&
          !file.type.startsWith("video/")
        ) {
          message.error(`${file.name} is not a valid image or video.`);
          continue; // skip invalid file
        }
        const result = await uploadFileToS3(file, bucketName, folder);
        uploadedFiles.push({
          file_name: file.name,
          file_path: result.Key,
          file_type: file.type.split("/")[0] === "video" ? "video" : "image",
          category_snap_id: categorySnapId,
          image_type: imageType,
        });
      }

      if (uploadedFiles.length > 0) {
        const payload = {
          order_id: id,
          load_id: selectedLoadData._id,
          dispatch_files: uploadedFiles,
        };
        dispatch(
          UpdateOrderDispatchFilesAPI(payload, () => {
            setUploadingFiles(false);
            setUploadingId(null);
            e.target.value = "";
          }),
        );
      } else {
        setUploadingFiles(false);
        setUploadingId(null);
      }
    } catch (error) {
      message.error("Failed to upload files.");
      setUploadingFiles(false);
      setUploadingId(null);
    }
  };

  const handleConfirmDeleteFile = async () => {
    const fileToDelete = selectedLoadData.dispatch_files.find(
      (f: any) => f._id === isDeleteId,
    );
    setDeleteFileLoader(true);
    try {
      if (fileToDelete?.file_path) {
        await deleteFromS3(fileToDelete.file_path);
      }
    } catch (error) {
      console.error("Failed to delete from S3", error);
    }

    const payload = {
      order_id: id,
      load_id: selectedLoadData._id,
      dispatch_files: [{ _id: isDeleteId, remove: 1 }],
    };
    dispatch(
      UpdateOrderDispatchFilesAPI(
        payload,
        () => {
          setDeleteFileLoader(false);
          setIsDeleteModal(false);
          setIsDeleteId("");
        },
        true,
      ),
    );
  };

  const handleRemoveFile = (fileId: string) => {
    if (!id || !selectedLoadData?._id) return;

    setIsDeleteId(fileId);
    setIsDeleteModal(true);
    return;
  };

  const currentLoadDetails = dispatchPlaning?.loadDetails[activeKey] || {};

  const handleSetDispatchPlanning = useCallback(
    (newData: any) => {
      if (newData?.loads === undefined) {
        setDispatchPlaning(newData);
        return;
      }

      const newLoadCount = parseInt(newData.loads) || 0;
      setDispatchPlaning((prev: any) => {
        const currentProducts = prev?.products || [];
        const currentLoadDetails = prev?.loadDetails || {};

        const updatedProducts = currentProducts.map((p: any) => {
          const newLoads = { ...p.loads };
          const newDispatchedLoads = { ...(p.dispatchedLoads || {}) };
          for (let i = 1; i <= newLoadCount; i++) {
            const key = i.toString();
            if (!(key in newLoads)) {
              newLoads[key] = 0;
            }
            if (!(key in newDispatchedLoads)) {
              newDispatchedLoads[key] = 0;
            }
          }
          return { ...p, loads: newLoads, dispatchedLoads: newDispatchedLoads };
        });

        const updatedLoadDetails = { ...currentLoadDetails };
        for (let i = 1; i <= newLoadCount; i++) {
          const key = i.toString();
          if (!(key in updatedLoadDetails)) {
            updatedLoadDetails[key] = {
              dispatchDate: "",
              trackingNumber: "",
              transporter: "",
              vehicleInfo: "",
              notes: "",
            };
          }
        }

        if (parseInt(activeKey) > newLoadCount && newLoadCount > 0) {
          setActiveKey("1");
        }

        return {
          ...prev,
          loads: newLoadCount,
          products: updatedProducts,
          loadDetails: updatedLoadDetails,
        };
      });
    },
    [activeKey],
  );

  const MoreOptionsMenu = () => {
    return (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => {
            setIsMarkAsDispatch(true);
            // navigate(`/orders/${data?._id}`);
          }}
        >
          <div className="text-black d-flex align-items-center gap-2 svg-20">
            Modify Dispatch Info
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const [dispatchModalOpen, setDispatchModalOpen] = useState(false);

  return getDispatchPlaningDetailsLoading ? (
    <div
      className="w-100 d-flex align-items-center justify-content-center"
      style={{ height: "calc(100vh - 12rem)" }}
    >
      <FullScreenLoader />
    </div>
  ) : (
    <div className="h-100">
      {isModifyDispatchPlaning && !isDispatchQty ? (
        <div className="h-100 d-flex flex-column">
          <div className="d-flex flex-md-nowrap flex-wrap gap-sm-3 justify-content-between align-items-center mb-2">
            <h2 className="text-black fw-bolder page-title mb-0 d-flex gap-2">
              <span
                onClick={() => {
                  setIsModifyDispatchPlaning(false);
                  setIsDispatchQty(false);
                  setTempProducts(dispatchPlaning.products);
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
                className="svg-24 cursor-pointer"
              >
                {svg?.backArrow}
              </span>{" "}
              Modify Dispatch Planning
            </h2>
            <div className="d-md-flex d-none justify-content-end align-items-center gap-3">
              <button
                className="btn btn-lg btn-outline-secondary min-w-100 text-uppercase"
                onClick={() => {
                  setIsModifyDispatchPlaning(false);
                  setTempProducts(dispatchPlaning.products);
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
              >
                CANCEL
              </button>
              <button
                className={`btn btn-lg min-w-100 px-5 btn-dark text-uppercase`}
                onClick={onSave}
                disabled={updateDispatchPlanningManageLoading}
              >
                {updateDispatchPlanningManageLoading ? <BtnLoader /> : "SAVE"}
              </button>
            </div>
          </div>
          <div className="mb-md-4 mb-3">
            <h4 className="fw-bold text-black mb-2 fs-5">
              Dispatch Planning List
            </h4>
            {groupedItems.categoryGroups.map((group, idx) => {
              const catName = group.category?.name || "Other Items";
              return (
                <div key={group.category?._id || idx} className="mb-4">
                  <h5 className="fw-bold text-black mb-3 fs-5">{catName}</h5>

                  {group.items.length > 0 && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-black mb-2 fs-6">{catName === "Bespoke / Bought-In Items" ? "Items" : "Products"}</h6>
                      <Table
                        dataSource={group.items}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={modifyDispatchPlaningColumns}
                        rowKey={(record) => record._id}
                        className="custom-table dispatch-modify-table mb-3"
                        bordered
                      />
                    </div>
                  )}

                  {group.parts.length > 0 && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-black mb-2 fs-6">Parts</h6>
                      <Table
                        dataSource={group.parts}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={modifyDispatchPlaningColumns}
                        rowKey={(record) => record._id}
                        className="custom-table dispatch-modify-table mb-3"
                        bordered
                      />
                    </div>
                  )}

                  {group.components.length > 0 && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-black mb-2 fs-6">Components</h6>
                      <Table
                        dataSource={group.components}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={modifyDispatchPlaningColumns}
                        rowKey={(record) => record._id}
                        className="custom-table dispatch-modify-table mb-3"
                        bordered
                      />
                    </div>
                  )}
                </div>
              );
            })}

            {groupedItems.otherItems.length > 0 && (
              <div className="mb-4">
                <h5 className="fw-bold text-black mb-2 fs-6">
                  Other Items Dispatch List
                </h5>
                <Table
                  dataSource={groupedItems.otherItems}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                  columns={modifyDispatchPlaningColumns}
                  rowKey={(record) => record._id}
                  className="custom-table dispatch-modify-table mb-3"
                  bordered
                />
              </div>
            )}

            {groupedItems.services.length > 0 && (
              <div className="mb-4">
                <h5 className="fw-bold text-black mb-2 fs-6">Service List</h5>
                <Table
                  dataSource={groupedItems.services}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                  columns={modifyDispatchPlaningColumns}
                  rowKey={(record) => record._id}
                  className="custom-table dispatch-modify-table"
                  bordered
                />
              </div>
            )}
          </div>
          <div className="row justify-content-center align-items-center mt-auto pb-4">
            <div className="col-sm-auto col-6">
              <button
                className="btn btn-lg btn-outline-secondary px-4 w-100 text-uppercase"
                onClick={() => {
                  setIsModifyDispatchPlaning(false);
                  setTempProducts(dispatchPlaning.products);
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
              >
                CANCEL
              </button>
            </div>
            <div className="col-sm-auto col-6">
              <button
                className={`btn btn-lg btn-primary px-5 w-100 text-uppercase`}
                onClick={onSave}
                disabled={updateDispatchPlanningManageLoading}
              >
                {updateDispatchPlanningManageLoading ? <BtnLoader /> : "SAVE"}
              </button>
            </div>
          </div>
        </div>
      ) : isModifyDispatchPlaning && isDispatchQty ? (
        <div className="h-100 d-flex flex-column">
          <div className="d-flex flex-md-nowrap flex-wrap gap-sm-3 justify-content-between align-items-center mb-2">
            <h2 className="text-black fw-bolder page-title mb-0 d-flex gap-2">
              <span
                onClick={() => {
                  setIsModifyDispatchPlaning(false);
                  setIsDispatchQty(false);
                  setTempProducts(dispatchPlaning.products);
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
                className="svg-24 cursor-pointer"
              >
                {svg?.backArrow}
              </span>{" "}
              Modify Dispatched Quantity Of Load {selectedLoadData?.load_number}
            </h2>
            <div className="d-md-flex d-none justify-content-end align-items-center gap-3">
              <button
                className="btn btn-lg btn-outline-secondary min-w-100 text-uppercase"
                onClick={() => {
                  setIsModifyDispatchPlaning(false);
                  setTempProducts(dispatchPlaning.products);
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
              >
                CANCEL
              </button>
              <button
                className={`btn btn-lg min-w-100 px-5 btn-dark text-uppercase`}
                onClick={onSave}
                disabled={updateDispatchActualManageLoading}
              >
                {updateDispatchActualManageLoading ? <BtnLoader /> : "SAVE"}
              </button>
            </div>
          </div>
          <div className="mb-md-4 mb-3">
            <h4 className="fw-bold text-black mb-2 fs-5">Dispatched List</h4>
            {groupedItems.categoryGroups.map((group, idx) => {
              const catName = group.category?.name || "Other Items";
              return (
                <div key={group.category?._id || idx} className="mb-4">
                  <h5 className="fw-bold text-black mb-3 fs-5">{catName}</h5>

                  {group.items.length > 0 && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-black mb-2 fs-6">{catName === "Bespoke / Bought-In Items" ? "Items" : "Products"}</h6>
                      <Table
                        dataSource={group.items}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={dispatchQtyColumns}
                        rowKey={(record) => record._id}
                        className="custom-table dispatch-modify-table mb-3"
                        bordered
                      />
                    </div>
                  )}

                  {group.parts.length > 0 && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-black mb-2 fs-6">Parts</h6>
                      <Table
                        dataSource={group.parts}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={dispatchQtyColumns}
                        rowKey={(record) => record._id}
                        className="custom-table dispatch-modify-table mb-3"
                        bordered
                      />
                    </div>
                  )}

                  {group.components.length > 0 && (
                    <div className="mb-3">
                      <h6 className="fw-bold text-black mb-2 fs-6">Components</h6>
                      <Table
                        dataSource={group.components}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={dispatchQtyColumns}
                        rowKey={(record) => record._id}
                        className="custom-table dispatch-modify-table mb-3"
                        bordered
                      />
                    </div>
                  )}
                </div>
              );
            })}

            {groupedItems.otherItems.length > 0 && (
              <div className="mb-4">
                <h5 className="fw-bold text-black mb-2 fs-6">
                  Other Items Dispatched List
                </h5>
                <Table
                  dataSource={groupedItems.otherItems}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                  columns={dispatchQtyColumns}
                  rowKey={(record) => record._id}
                  className="custom-table dispatch-modify-table mb-3"
                  bordered
                />
              </div>
            )}

            {groupedItems.services.length > 0 && (
              <div className="mb-4">
                <h5 className="fw-bold text-black mb-2 fs-6">
                  Service Dispatched List
                </h5>
                <Table
                  dataSource={groupedItems.services}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                  columns={dispatchQtyColumns}
                  rowKey={(record) => record._id}
                  className="custom-table dispatch-modify-table"
                  bordered
                />
              </div>
            )}
          </div>
          <div className="row justify-content-center align-items-center mt-auto pb-4">
            <div className="col-sm-auto col-6">
              <button
                className="btn btn-lg btn-outline-secondary px-4 w-100 text-uppercase"
                onClick={() => {
                  setIsModifyDispatchPlaning(false);
                  setTempProducts(dispatchPlaning.products);
                  setEditingRowId(null);
                  setEditingRowBackup(null);
                }}
              >
                CANCEL
              </button>
            </div>
            <div className="col-sm-auto col-6">
              <button
                className={`btn btn-lg btn-primary px-5 w-100 text-uppercase`}
                onClick={onSave}
                disabled={updateDispatchActualManageLoading}
              >
                {updateDispatchActualManageLoading ? <BtnLoader /> : "SAVE"}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-md-3 mb-2">
            <h4 className="fs-5 fw-bold text-black mb-0">Dispatch Planning</h4>
            {dispatchPlaningDetails ? (
              <h4 className="fs-5 fw-bold text-black mb-0 gap-md-3 d-flex align-items-center gap-2 ms-auto">
                No of Load: {dispatchPlaningDetails?.load_number}{" "}
                {DispatchPlaningStatusArray.includes(
                  orderDetails?.order_status,
                ) ? (
                  <span
                    className="svg-32 cursor-pointer"
                    onClick={() => {
                      setIsEditLoadData({
                        loads: dispatchPlaningDetails?.load_number,
                      });
                      setAddIsLoadModal(true);
                    }}
                  >
                    {svg?.tableEditIcon}
                  </span>
                ) : (
                  ""
                )}
              </h4>
            ) : (
              ""
            )}
          </div>
          {!dispatchPlaningDetails ? (
            <div className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white flex-fill">
              <div className="d-flex flex-column align-items-center justify-content-center gap-2 text-center">
                <div>{svg?.dispatchTruckIcon}</div>

                <h5 className="fs-5 fw-bold text-black ">
                  Number of Load / Number of Vehicle not added yet!
                </h5>
                <p className="fs-6 text-4a4a4a ">
                  Transport details are incomplete. Kindly add the number of
                  loads or vehicles required before continuing.
                </p>
                {DispatchPlaningStatusArray.includes(
                  orderDetails?.order_status,
                ) ? (
                  <div>
                    <button
                      className="btn btn-lg btn-primary"
                      onClick={() => setAddIsLoadModal(true)}
                    >
                      ADD LOAD
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <div>
              <div className="d-flex flex-wrap align-items-center justify-content-between mb-md-4 mb-3 gap-2">
                <div className="customHorizontalTabs bg-white overflow-hidden border-0 rounded-3 d-inline-block mw-100">
                  <Tabs
                    activeKey={activeKey}
                    onChange={(key: string) => {
                      const newData = dispatchPlaningDetails?.load_id?.find(
                        (elem: any) => elem?._id === key,
                      );
                      setActiveKey(key);
                      setSelectedLoadData(newData);
                    }}
                    items={items?.map(({ label, key }) => ({
                      label,
                      key,
                    }))}
                  />
                </div>
                {/* <div>
                  <button
                    className="btn btn-lg btn-primary"
                    onClick={() => {
                      setIsMarkAsDispatch(true);
                    }}
                  >
                    Mark As Dispatched
                  </button>
                </div> */}
                {DispatchPlaningStatusArray.includes(
                  orderDetails?.order_status,
                ) ? (
                  selectedLoadData?.status === "dispatched" ? (
                    <div className="d-flex align-items-center gap-2 ms-auto">
                      <span
                        className={
                          "d-inline-flex align-items-center fw-semibold fs-6 svg-10 quotation-status statusDraft "
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {svg.dotIcon}
                        <span className="ms-1 d-inline-block lh-normal">
                          Dispatched
                        </span>
                      </span>
                      <Dropdown
                        overlay={() => MoreOptionsMenu()}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="cursor-pointer"
                        overlayClassName="moreOptionDropdown"
                      >
                        <span className="svg-32 svg-outline-primary">
                          {svg?.tableMoreOption}
                        </span>
                      </Dropdown>
                    </div>
                  ) : (
                    selectedLoadData?._id && (
                      <div>
                        <button
                          className={`btn btn-lg btn-lg-mob btn-primary`}
                          onClick={() => {
                            if (!selectedLoadData?.dispatched_details) {
                              message.error("please enter dispatched details");
                              return;
                            }
                            if (
                              dispatchPlaning?.products?.filter(
                                (p: any) => (p.loads?.[activeKey] || 0) > 0,
                              )?.length === 0
                            ) {
                              message.error("please add products to the load");
                              return;
                            }
                            const productsInLoad =
                              dispatchPlaning?.products?.filter(
                                (p: any) =>
                                  (p.loads?.[activeKey] || 0) > 0 ||
                                  (p.dispatchedLoads?.[activeKey] || 0) > 0,
                              );

                            const totalDispatchedQty = productsInLoad?.reduce(
                              (sum: number, p: any) =>
                                sum +
                                Number(p.dispatchedLoads?.[activeKey] || 0),
                              0,
                            );

                            if (totalDispatchedQty === 0) {
                              message.error("Please add dispatched quantity.");
                              return;
                            }

                            if (selectedLoadData?.status !== "dispatched") {
                              const allLoads =
                                dispatchPlaningDetails?.load_id || [];
                              const otherLoads = allLoads.filter(
                                (load: any) => load?._id !== activeKey,
                              );
                              const allOtherDispatched = otherLoads.every(
                                (load: any) => load?.status === "dispatched",
                              );

                              if (allOtherDispatched) {
                                const undispatchedProducts: any[] = [];
                                tempProducts.forEach((p: any) => {
                                  const totalOrdered = Number(
                                    p.totalQuantity || 0,
                                  );
                                  const totalDispatched = Object.entries(
                                    p.dispatchedLoads || {},
                                  ).reduce(
                                    (sum: number, [loadId, qty]) =>
                                      sum + Number(qty || 0),
                                    0,
                                  );
                                  if (totalDispatched < totalOrdered) {
                                    undispatchedProducts.push(p);
                                  }
                                });

                                if (undispatchedProducts.length > 0) {
                                  setUndispatchedProductsList(
                                    undispatchedProducts,
                                  );
                                  setUndispatchedModalOpen(true);
                                  return;
                                }
                              }
                            }

                            const dispatchChecklist =
                              selectedLoadData?.dispatch_checklist || [];
                            const questions = dispatchChecklist.flatMap(
                              (c: any) => c.questions_data || [],
                            );
                            if (
                              dispatchChecklist.length > 0 &&
                              questions.length > 0
                            ) {
                              setIsDispatchChecklistModal(true);
                            } else {
                              setPendingDispatchChecklist(null);
                              setIsMarkAsDispatch(true);
                            }
                          }}
                        >
                          {selectedLoadData?.status === "dispatched"
                            ? "Mark As Undispatched"
                            : "Mark As Dispatched"}
                        </button>
                      </div>
                    )
                  )
                ) : (
                  ""
                )}
              </div>

              {selectedLoadData?.status === "dispatched" &&
                (selectedLoadData?.dispatch_checklist || []).flatMap(
                  (c: any) => c.questions_data || [],
                ).length > 0 && (
                  <div className="mb-4">
                    <div className="card border-0 shadow-sm rounded-4 bg-white">
                      <div className="card-body p-md-4 p-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
                        <h4 className="fs-5 fw-bold text-black mb-0">
                          Load {selectedLoadData?.load_number} Dispatch Checklist Details
                        </h4>
                        <button
                          className="btn btn-primary"
                          onClick={() => setIsViewDispatchChecklistModalOpen(true)}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                )}

              <div className="mb-4">
                <div className="mb-md-3 mb-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
                  <h4 className="fs-5 fw-bold text-black mb-0">
                    Load {selectedLoadData?.load_number} Dispatch Team
                  </h4>
                  {DispatchPlaningStatusArray.includes(
                    orderDetails?.order_status,
                  ) ? (
                    selectedLoadData?.status === "dispatched" ? (
                      ""
                    ) : (
                      <span
                        className="fw-bold fs-6 cursor-pointer text-primary text-decoration-underline"
                        onClick={() => setDispatchModalOpen(true)}
                      >
                        Modify
                      </span>
                    )
                  ) : (
                    ""
                  )}
                  {dispatchModalOpen && (
                    <AddDispatchTeamModal
                      visible={dispatchModalOpen}
                      onClose={() => setDispatchModalOpen(false)}
                      selectedLoadData={selectedLoadData}
                      setSelectedLoadData={setSelectedLoadData}
                      employeList={
                        selectedLoadData?.employee_ids?.length > 0
                          ? selectedLoadData?.employee_ids?.map(
                              (elem: any) => elem?._id,
                            )
                          : []
                      }
                    />
                  )}
                </div>
                <div className="card border-0 shadow-sm rounded-4 bg-white">
                  <div className="card-body d-flex flex-wrap gap-md-4 gap-3 p-md-4 p-3">
                    {selectedLoadData?.employee_ids?.length > 0 ? (
                      selectedLoadData?.employee_ids?.map((member: any) => (
                        <div className="d-flex align-items-center gap-2">
                          <div className="img-34">
                            <img
                              src={
                                member?.profile_pic
                                  ? getFullAwsUrl(member?.profile_pic)
                                  : DefaultProfileImage
                              }
                              className="rounded-circle object-fit-cover w-100 h-100"
                              width={34}
                              height={34}
                              onError={(e: any) => {
                                e.target.onerror = null;
                                e.target.src = DefaultProfileImage;
                              }}
                            />
                          </div>
                          <h5 className="mb-0 fw-semibold fs-5 mob-fs-5 text-break">
                            {`${CapitalizeFirstWord(
                              decryptByText(member?.first_name),
                            )} ${CapitalizeFirstWord(
                              decryptByText(member?.last_name),
                            )}`}
                          </h5>
                        </div>
                      ))
                    ) : (
                      <div className="d-flex align-items-center justify-content-center gap-2 text-949494 w-100">
                        No dispatch team added yet
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-md-3 mb-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
                  <h4 className="fs-5 fw-bold text-black mb-0">
                    Load {selectedLoadData?.load_number} Details
                  </h4>
                  {DispatchPlaningStatusArray.includes(
                    orderDetails?.order_status,
                  ) ? (
                    <span
                      className={`fw-bold fs-6 cursor-pointer text-primary text-decoration-underline  ${
                        selectedLoadData?.status === "dispatched"
                          ? "text-secondary"
                          : "text-primary"
                      }`}
                      onClick={() => {
                        if (selectedLoadData?.status === "dispatched") return;
                        setIsDispatchDetails(true);
                        setIsDispatchDetailsData(selectedLoadData);
                      }}
                    >
                      Modify
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white">
                  <div className="row gy-md-4 gy-3">
                    <div className="col-lg-3 col-md-4 col-sm-6">
                      <label className="fs-6 fw-normal text-secondary d-block mb-1">
                        Dispatch Date
                      </label>
                      <span className="fw-semibold text-dark fs-6">
                        {selectedLoadData?.dispatched_details?.dispatched_at
                          ? momentDDMMYY(
                              selectedLoadData?.dispatched_details
                                ?.dispatched_at,
                            )
                          : "-"}
                      </span>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6">
                      <label className="fs-6 fw-normal text-secondary d-block mb-1">
                        Tracking Number
                      </label>
                      <span className="fw-semibold text-dark fs-6">
                        {selectedLoadData?.dispatched_details
                          ?.tracking_number || "-"}
                      </span>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6">
                      <label className="fs-6 fw-normal text-secondary d-block mb-1">
                        Transporter
                      </label>
                      <span className="fw-semibold text-dark fs-6">
                        {selectedLoadData?.dispatched_details?.transporter ||
                          "-"}
                      </span>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6">
                      <label className="fs-6 fw-normal text-secondary d-block mb-1">
                        Vehicle Info
                      </label>
                      <span className="fw-semibold text-dark fs-6">
                        {selectedLoadData?.dispatched_details?.vehicle_info ||
                          "-"}
                      </span>
                    </div>

                    <div className="col-12">
                      <label className="fs-6 fw-normal text-secondary d-block mb-1">
                        Dispatch Notes
                      </label>
                      <span className="fw-semibold text-dark fs-6">
                        {selectedLoadData?.dispatched_details?.note || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center pb-2 border-bottom mb-4 ">
                <h4 className="fs-5 fw-bold text-black mb-0">
                  Dispatch List for Load {selectedLoadData?.load_number}
                </h4>
                <div>
                  {DispatchPlaningStatusArray.includes(
                    orderDetails?.order_status,
                  ) ? (
                    <div className="d-flex align-items-center gap-md-3 gap-2 mob-w-100 justify-content-between">
                      <span
                        className={`fw-bold fs-6 cursor-pointer text-decoration-underline ${
                          selectedLoadData?.status === "dispatched"
                            ? "text-secondary"
                            : "text-primary"
                        }`}
                        onClick={() => {
                          if (selectedLoadData?.status === "dispatched") return;
                          setIsDispatchQty(false);
                          setTempProducts(dispatchPlaning.products);
                          setIsModifyDispatchPlaning(true);
                          document
                            .querySelector(".page-content")
                            ?.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Manage Plan Quantity
                      </span>
                      <span
                        className={`fw-bold fs-6 cursor-pointer text-decoration-underline ${
                          selectedLoadData?.status === "dispatched"
                            ? "text-secondary"
                            : "text-primary"
                        }`}
                        onClick={() => {
                          if (selectedLoadData?.status === "dispatched") return;
                          setIsDispatchQty(true);
                          setTempProducts(dispatchPlaning.products);
                          setIsModifyDispatchPlaning(true);
                          document
                            .querySelector(".page-content")
                            ?.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        Add Dispatched Qty
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {groupedItems.categoryGroups.map((group, idx) => {
                const catName = group.category?.name || "Other Items";
                const filteredItems = group.items.filter(
                  (item: any) =>
                    Number(item.loads?.[activeKey] || 0) > 0 ||
                    Number(item.dispatchedLoads?.[activeKey] || 0) > 0,
                );
                const filteredParts = group.parts.filter(
                  (item: any) =>
                    Number(item.loads?.[activeKey] || 0) > 0 ||
                    Number(item.dispatchedLoads?.[activeKey] || 0) > 0,
                );
                const filteredComponents = group.components.filter(
                  (item: any) =>
                    Number(item.loads?.[activeKey] || 0) > 0 ||
                    Number(item.dispatchedLoads?.[activeKey] || 0) > 0,
                );

                const hasItemsInLoad =
                  filteredItems.length > 0 ||
                  filteredParts.length > 0 ||
                  filteredComponents.length > 0;

                if (!hasItemsInLoad) return null;

                return (
                  <div key={group.category?._id || idx} className="mb-5">
                    <h4 className="fs-5 fw-bold text-black mb-3">
                      {catName}
                    </h4>

                    {filteredItems.length > 0 && (
                      <div className="mb-4">
                        <h6 className="fw-bold text-black mb-2 fs-6">
                          Products
                        </h6>
                        <Table
                          dataSource={filteredItems}
                          scroll={{ x: "max-content" }}
                          pagination={false}
                          columns={columns}
                          rowKey={(record) => record._id}
                          className="custom-table mb-4"
                          bordered
                        />
                      </div>
                    )}

                    {filteredParts.length > 0 && (
                      <div className="mb-4">
                        <h6 className="fw-bold text-black mb-2 fs-6">
                          Parts
                        </h6>
                        <Table
                          dataSource={filteredParts}
                          scroll={{ x: "max-content" }}
                          pagination={false}
                          columns={columns}
                          rowKey={(record) => record._id}
                          className="custom-table mb-4"
                          bordered
                        />
                      </div>
                    )}

                    {filteredComponents.length > 0 && (
                      <div className="mb-4">
                        <h6 className="fw-bold text-black mb-2 fs-6">
                          Components
                        </h6>
                        <Table
                          dataSource={filteredComponents}
                          scroll={{ x: "max-content" }}
                          pagination={false}
                          columns={columns}
                          rowKey={(record) => record._id}
                          className="custom-table mb-4"
                          bordered
                        />
                      </div>
                    )}

                    <h6 className="fw-bold text-black mb-2 fs-6">
                      Dispatch Images/Videos for Load {selectedLoadData?.load_number}
                    </h6>

                    <div className="d-flex flex-wrap gap-3 mt-3">
                      {(() => {
                        const filesInGroup =
                          selectedLoadData?.dispatch_files?.filter(
                            (f: any) =>
                              String(f.category_snap_id) ===
                                String(group.category?._id) &&
                              f.image_type === "product",
                          ) || [];

                        return filesInGroup.length > 0 ? (
                          filesInGroup.map((file: any, fileIndex: number) => {
                            const fileUrl = file?.file_path
                              ? getFullAwsUrl(file?.file_path)
                              : file?.file_url;

                            const handlePreview = () => {
                              setPreviewFiles(
                                filesInGroup.map((f: any) =>
                                  f.file_path
                                    ? getFullAwsUrl(f.file_path)
                                    : f.file_url,
                                ),
                              );
                              setPreviewIndex(fileIndex);
                              setPreviewModalOpen(true);
                            };

                            return (
                              <div
                                key={
                                  file?._id || file?.file_path || file?.file_url
                                }
                                className="position-relative border rounded overflow-hidden dispatch-images-main cursor-pointer dispatch-image-list"
                                style={{ width: "100px", height: "100px" }}
                                onClick={handlePreview}
                              >
                                {file?.file_type === "image" ? (
                                  <Image
                                    src={fileUrl}
                                    alt={file?.file_name}
                                    className="w-100 h-100 object-fit-cover"
                                    preview={false}
                                  />
                                ) : (
                                  <div className="w-100 h-100 position-relative">
                                    <video
                                      src={fileUrl}
                                      className="w-100 h-100 object-fit-cover"
                                    />
                                    <div
                                      className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-circle text-white"
                                      style={{ width: "32px", height: "32px" }}
                                    >
                                      <span className="svg-16">
                                        {svg?.videoPlayIcon}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {!(
                                  uploadingFiles &&
                                  uploadingId === file?.category_snap_id
                                ) &&
                                  DispatchPlaningStatusArray.includes(
                                    orderDetails?.order_status,
                                  ) && (
                                    <div
                                      className="w-100 h-100 position-absolute top-0 start-0"
                                      style={{ pointerEvents: "none" }}
                                    >
                                      <div
                                        className="position-absolute d-flex gap-2 svg-24 cursor-pointer"
                                        style={{
                                          top: 2,
                                          right: 2,
                                          zIndex: 10,
                                          pointerEvents: "auto",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleRemoveFile(file._id);
                                        }}
                                      >
                                        {svg?.deleteS3ImageIcon}
                                      </div>
                                    </div>
                                  )}
                              </div>
                            );
                          })
                        ) : DispatchPlaningStatusArray.includes(
                            orderDetails?.order_status,
                          ) ? (
                          ""
                        ) : (
                          <div className="bg-white p-3 rounded w-100 text-center text-949494">
                            You have not uploaded any dispatch images/videos for
                            this category.
                          </div>
                        );
                      })()}

                      {DispatchPlaningStatusArray.includes(
                        orderDetails?.order_status,
                      ) ? (
                        <div
                          className="rounded bg-white d-flex flex-column align-items-center justify-content-center cursor-pointer position-relative"
                          style={{
                            width: "100px",
                            height: "100px",
                            opacity:
                              uploadingFiles &&
                              uploadingId === group.category?._id
                                ? 0.5
                                : 1,
                            border: "2px dashed #949494",
                          }}
                          onDragOver={(e) => {
                            e.preventDefault();
                          }}
                          onDrop={(e) => {
                            e.preventDefault();

                            const files = e.dataTransfer.files;

                            if (files.length > 0) {
                              handleUploadFiles(
                                { target: { files } },
                                group.category?._id,
                                "product",
                              );
                            }
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            accept="image/*,video/*"
                            className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
                            title="Upload Files"
                            onChange={(e) =>
                              handleUploadFiles(
                                e,
                                group.category?._id,
                                "product",
                              )
                            }
                            disabled={
                              uploadingFiles &&
                              uploadingId === group.category?._id
                            }
                            style={{
                              cursor:
                                uploadingFiles &&
                                uploadingId === group.category?._id
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          />
                          {uploadingFiles &&
                          uploadingId === group.category?._id ? (
                            <span className="spinner-border spinner-border-sm text-primary"></span>
                          ) : (
                            <span className="fs-3 text-secondary svg-46">
                              {svg?.imageUpload}
                            </span>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              })}

              {(() => {
                const filteredOtherItems = groupedItems.otherItems.filter(
                  (item: any) =>
                    Number(item.loads?.[activeKey] || 0) > 0 ||
                    Number(item.dispatchedLoads?.[activeKey] || 0) > 0,
                );

                return (
                  filteredOtherItems.length > 0 && (
                    <div className="mb-5">
                      <div className="mb-md-3 mb-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
                        <h4 className="fs-5 fw-bold text-black mb-0">
                          Other Items List for Load {selectedLoadData?.load_number}
                        </h4>
                      </div>

                      <Table
                        dataSource={filteredOtherItems}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={columns}
                        rowKey={(record) => record._id}
                        className="custom-table mb-4"
                        bordered
                      />
                    </div>
                  )
                );
              })()}

              {(() => {
                const filteredServices = groupedItems.services.filter(
                  (item: any) =>
                    Number(item.loads?.[activeKey] || 0) > 0 ||
                    Number(item.dispatchedLoads?.[activeKey] || 0) > 0,
                );

                return (
                  filteredServices.length > 0 && (
                    <div className="mb-5">
                      <div className="mb-md-3 mb-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
                        <h4 className="fs-5 fw-bold text-black mb-0">
                          Service List for Load {selectedLoadData?.load_number}
                        </h4>
                      </div>

                      <Table
                        dataSource={filteredServices}
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        columns={columns}
                        rowKey={(record) => record._id}
                        className="custom-table mb-4"
                        bordered
                      />

                      <h4 className="fs-5 fw-bold text-black mb-md-3 mb-2 d-flex align-items-center justify-content-between gap-2">
                        Services Images/Videos for Load{" "}
                        {selectedLoadData?.load_number}
                      </h4>

                      <div className="d-flex flex-wrap gap-3 mt-3">
                        {(() => {
                          const filesInGroup =
                            selectedLoadData?.dispatch_files?.filter(
                              (f: any) => f.image_type === "service",
                            ) || [];

                          return filesInGroup.length > 0 ? (
                            filesInGroup.map((file: any, fileIndex: number) => {
                              const fileUrl = file?.file_path
                                ? getFullAwsUrl(file?.file_path)
                                : file?.file_url;

                              const handlePreview = () => {
                                setPreviewFiles(
                                  filesInGroup.map((f: any) =>
                                    f.file_path
                                      ? getFullAwsUrl(f.file_path)
                                      : f.file_url,
                                  ),
                                );
                                setPreviewIndex(fileIndex);
                                setPreviewModalOpen(true);
                              };

                              return (
                                <div
                                  key={
                                    file?._id ||
                                    file?.file_path ||
                                    file?.file_url
                                  }
                                  className="position-relative border rounded overflow-hidden dispatch-images-main cursor-pointer dispatch-image-list"
                                  style={{ width: "100px", height: "100px" }}
                                  onClick={handlePreview}
                                >
                                  {file?.file_type === "image" ? (
                                    <Image
                                      src={fileUrl}
                                      alt={file?.file_name}
                                      className="w-100 h-100 object-fit-cover"
                                      preview={false}
                                    />
                                  ) : (
                                    <div className="w-100 h-100 position-relative">
                                      <video
                                        src={fileUrl}
                                        className="w-100 h-100 object-fit-cover"
                                      />
                                      <div
                                        className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-circle text-white"
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                        }}
                                      >
                                        <span className="svg-16">
                                          {svg?.videoPlayIcon}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {!(
                                    uploadingFiles &&
                                    uploadingId === file?.category_snap_id
                                  ) &&
                                    DispatchPlaningStatusArray.includes(
                                      orderDetails?.order_status,
                                    ) && (
                                      <div
                                        className="w-100 h-100 position-absolute top-0 start-0"
                                        style={{ pointerEvents: "none" }}
                                      >
                                        <div
                                          className="position-absolute d-flex gap-2 svg-24 cursor-pointer"
                                          style={{
                                            top: 2,
                                            right: 2,
                                            zIndex: 10,
                                            pointerEvents: "auto",
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemoveFile(file._id);
                                          }}
                                        >
                                          {svg?.deleteS3ImageIcon}
                                        </div>
                                      </div>
                                    )}
                                </div>
                              );
                            })
                          ) : DispatchPlaningStatusArray.includes(
                              orderDetails?.order_status,
                            ) ? (
                            ""
                          ) : (
                            <div className="bg-white p-3 rounded w-100 text-center text-949494">
                              You have not uploaded any dispatch images/videos
                              for services.
                            </div>
                          );
                        })()}

                        {DispatchPlaningStatusArray.includes(
                          orderDetails?.order_status,
                        ) ? (
                          <div
                            className="rounded bg-white d-flex flex-column align-items-center justify-content-center cursor-pointer position-relative"
                            style={{
                              width: "100px",
                              height: "100px",
                              opacity:
                                uploadingFiles && uploadingId === null
                                  ? 0.5
                                  : 1,
                              border: "2px dashed #949494",
                            }}
                          >
                            <input
                              type="file"
                              multiple
                              accept="image/*,video/*"
                              className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
                              title="Upload Files"
                              onChange={(e) =>
                                handleUploadFiles(e, null, "service")
                              }
                              disabled={uploadingFiles && uploadingId === null}
                              style={{
                                cursor:
                                  uploadingFiles && uploadingId === null
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            />
                            {uploadingFiles && uploadingId === null ? (
                              <span className="spinner-border spinner-border-sm text-primary"></span>
                            ) : (
                              <span className="fs-3 text-secondary svg-46">
                                {svg?.imageUpload}
                              </span>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )
                );
              })()}
            </div>
          )}
          {addIsLoadModal && (
            <AddDispatchLoadModal
              visible={addIsLoadModal}
              setIsModalVisible={setAddIsLoadModal}
              setDispatchPlaning={handleSetDispatchPlanning}
              isEditLoadData={isEditLoadData}
              setActiveKey={setActiveKey}
            />
          )}
        </>
      )}
      {isDispatchDetails && (
        <DispatchDetailsModal
          visible={isDispatchDetails}
          setIsModalVisible={setIsDispatchDetails}
          isDispatchDetailsData={isDispatchDetailsData}
          setIsDispatchDetailsData={setIsDispatchDetailsData}
        />
      )}
      {isDeleteModal && (
        <CommonDeleteModal
          visible={isDeleteModal}
          setIsModalVisible={setIsDeleteModal}
          handleDelete={handleConfirmDeleteFile}
          title={"Remove This File, Are You Sure?"}
          description={
            "Are you sure you want to remove this file? All associated data will be permanently deleted."
          }
          setIsDeleteId={setIsDeleteId}
          isLoading={deleteFileLoader}
          buttonName="REMOVE"
        />
      )}
      {isOverDispatchModal && (
        <OverLoadConfirmationModal
          isOverDispatchData={isOverDispatchData}
          visible={isOverDispatchModal}
          setIsModalVisible={setIsOverDispatchModal}
          onSucess={submitActualDispatch}
        />
      )}
      {isMarkAsDispatch && (
        <MarkAsDoneDispatchModal
          visible={isMarkAsDispatch}
          setIsModalVisible={setIsMarkAsDispatch}
          selectedLoad={selectedLoadData}
          onSucess={() => {
            if (
              !selectedLoadData?.dispatched_details ||
              !selectedLoadData?.dispatched_details?.dispatched_at
            ) {
              message.error("please enter dispatched details by modify");
              setIsDispatchDetails(true);
              setIsDispatchDetailsData(selectedLoadData);
            } else {
              const payload: any = {
                order_id: id,
                load_id: selectedLoadData._id,
                status:
                  selectedLoadData?.status === "dispatched"
                    ? "added_dispatched_items" // This is the NOT dispatched status from DispatchPlanningLoadStatus
                    : "dispatched",
              };
              if (pendingDispatchChecklist) {
                payload.dispatch_checklist = pendingDispatchChecklist;
              }
              const handleSuccess = () => {
                setIsMarkAsDispatch(false);
                setIsDispatchChecklistModal(false);
                setPendingDispatchChecklist(null);
              };
              dispatch(UpdateOrderDispatchStatusAPI(payload, handleSuccess));
            }
          }}
          title={
            selectedLoadData?.status === "dispatched"
              ? "Modify Dispatch Info, Are You Sure?"
              : `Mark As Dispatched for Load ${selectedLoadData?.load_number}, Are You Sure?`
          }
          description={
            selectedLoadData?.status === "dispatched"
              ? "This action will allow you to update the dispatch information for this load. Any changes made will update to client when Mark as Dispatched again? Please confirm to proceed."
              : `This action will mark Load ${selectedLoadData?.load_number} as dispatched and record the dispatch details. Please ensure all shipment information is correct before proceeding.`
          }
        />
      )}
      {previewModalOpen && (
        <CommonFilePreviewModal
          visible={previewModalOpen}
          onClose={() => {
            setPreviewModalOpen(false);
            setPreviewFiles([]);
            setPreviewIndex(0);
          }}
          files={previewFiles}
          activeIndex={previewIndex}
          onActiveIndexChange={setPreviewIndex}
        />
      )}
      {undispatchedModalOpen && (
        <DispatchLastLoadErrorModal 
        undispatchedModalOpen={undispatchedModalOpen}
        setUndispatchedModalOpen={setUndispatchedModalOpen}
        undispatchedProductsList={undispatchedProductsList}
        />
      )}
      {isDispatchChecklistModal && (
        <FillDispatchChecklistModal
          visible={isDispatchChecklistModal}
          setIsModalVisible={setIsDispatchChecklistModal}
          selectedLoadData={selectedLoadData}
          onSave={(formattedChecklist: any) => {
            setPendingDispatchChecklist(formattedChecklist);
            setIsMarkAsDispatch(true);
          }}
        />
      )}
      {isViewDispatchChecklistModalOpen && (
        <ViewDispatchChecklistModal
          visible={isViewDispatchChecklistModalOpen}
          setIsModalVisible={setIsViewDispatchChecklistModalOpen}
          selectedLoadData={selectedLoadData}
        />
      )}
    </div>
  );
};

export default DispatchPlanning;
